const logotext = "Jeremy Asirwaad";
const meta = {
	title: "Jeremy Asirwaad",
	description: "Jeremy Asirwaad - Full stack devloper - Portfolio"
};

const introdata = {
	title: "I’m Jeremy",
	animated: {
		first: "I love coding",
		second: "I code cool websites",
		third: "I develop mobile apps"
	},
	description: "A Self made, Passionate, Enthusiastic Web Developer",
	your_img_url:
		"https://firebasestorage.googleapis.com/v0/b/startup-st.appspot.com/o/jnew2.png?alt=media&token=987e3abb-4d9d-4982-886f-592384246a51"
};

const dataabout = {
	title: "About Myself",
	aboutme:
		"Currently persuing bachelor of Engineering (Information Technology) at Government College of Technology, Coimbatore. Proficient in building mobile apps and responsive websites.  "
};
const worktimeline = [
	{
		jobtitle: "Flutter Developer - Internship",
		where: "TNEA(TamilNadu Engineering Admissions)",
		date: "April 2022 - July 2022"
	},
	{
		jobtitle: "Fullstack Developer - Internship",
		where: "Aaronz - Dubai",
		date: "Dec 2021 - June 2022"
	}
];

const skills = [
	{
		name: "React",
		value: 90
	},
	{
		name: "Node",
		value: 85
	},
	{
		name: "Javascript",
		value: 85
	},
	{
		name: "Express",
		value: 80
	},
	{
		name: "Flutter",
		value: 85
	},
	{
		name: "MongoDB",
		value: 85
	},
	{
		name: "GitHub",
		value: 90
	}
];

const services = [
	{
		title: "Web-Development - MERN stack"
		// description:
		// 	"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at nisl euismod urna bibendum sollicitudin."
	},
	{
		title: "Mobile Apps - Flutter"
		// description:
		// 	"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed at nisl euismod urna bibendum sollicitudin."
	}
];

const dataportfolio = [
	{
		img: "https://firebasestorage.googleapis.com/v0/b/startup-st.appspot.com/o/Screenshot%202022-07-14%20at%201.50.25%20AM.png?alt=media&token=a35bbccf-4ccd-46a5-a5c3-c37316725248",
		desctiption: "StartUp Gateway",
		link: "https://startupgateway.pages.dev/"
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/startup-st.appspot.com/o/Screenshot%202022-07-14%20at%201.53.02%20AM.png?alt=media&token=51bf12fd-c144-4fd1-b3f3-df9af1281f5f",
		desctiption:
			" A professional looking full stack MERN project, where employers can post jobs and students can check for job opportunities",
		link: "https://gct-frontend.pages.dev/"
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/startup-st.appspot.com/o/Screenshot%202022-07-14%20at%202.26.05%20AM.png?alt=media&token=e06ba03d-3d01-46b0-8140-a70c3ae1e3d4",
		desctiption: "Flutter Dashboard App",
		link: "https://github.com/jeremyasirwaad/laptopapp"
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/startup-st.appspot.com/o/Screenshot%202022-07-14%20at%201.53.49%20AM.png?alt=media&token=caf821b4-e47b-4a49-b809-eaf11b2acb59",
		desctiption: "StartUp Stories - Inspiring startup stories from GCT",
		link: "https://startupgatewaystories.pages.dev/"
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/startup-st.appspot.com/o/Screenshot%202022-07-14%20at%201.59.33%20AM.png?alt=media&token=67bc1d6f-fc0a-4ed2-8e6a-7df05ffd5593",
		desctiption: "StartTalent - Dashboard to manage internship profiles",
		link: "https://starttalent.pages.dev/"
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/startup-st.appspot.com/o/Screenshot%202022-07-14%20at%201.55.34%20AM.png?alt=media&token=62b7588a-93d3-4cdd-b2e4-c05a8af2fb0c",
		desctiption: "React - Movie App",
		link: "https://movieapp-83q.pages.dev/"
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/startup-st.appspot.com/o/WhatsApp%20Image%202022-07-14%20at%201.52.38%20AM.jpeg?alt=media&token=d19d43a7-083d-45e3-8436-b53a1ff1ba78",
		desctiption: "StepUp (Mobile View Only)",
		link: "https://stepup.pages.dev/home"
	},
	{
		img: "https://firebasestorage.googleapis.com/v0/b/startup-st.appspot.com/o/Screenshot%202022-07-14%20at%202.42.29%20AM.png?alt=media&token=cb531ef8-2aa0-41ca-9e7e-a53b3ff0b66e",
		desctiption: "Weather App - Vennila Js - Enable Location Services",
		link: "https://mystifying-austin-982566.netlify.app/"
	}
];

const contactConfig = {
	YOUR_EMAIL: "asirwaadj@gmail.com",
	YOUR_FONE: "+91-9843632220",
	description:
		"Available for telephone calls throughout the day till 27th of July 2022. ",
	YOUR_SERVICE_ID: "service_id",
	YOUR_TEMPLATE_ID: "template_id",
	YOUR_USER_ID: "user_id"
};

const socialprofils = {
	github: "https://github.com/jeremyasirwaad",
	facebook: "https://www.facebook.com/profile.php?id=100010741335461",
	linkedin: "https://www.linkedin.com/in/jeremy-asirwaad-182b93192",
	instagram: "https://www.instagram.com/_._.jeremy._"
};
export {
	meta,
	dataabout,
	dataportfolio,
	worktimeline,
	skills,
	services,
	introdata,
	contactConfig,
	socialprofils,
	logotext
};
